import { pathnameToEnglishSegments } from '@/lib/intl-seo';

/**
 * www → apex (Google’da tek tercih edilen host için canonical tutarlılığı)
 */
function stripWwwOrigin(originOrUrl) {
  if (!originOrUrl) return originOrUrl;
  try {
    const u = new URL(
      originOrUrl.startsWith('http') ? originOrUrl : `https://${originOrUrl}`,
    );
    if (u.hostname.startsWith('www.')) u.hostname = u.hostname.slice(4);
    return u.origin;
  } catch {
    return String(originOrUrl)
      .replace(/\/$/, '')
      .replace(/^(https?:\/\/)www\./i, '$1');
  }
}

/**
 * Public site URL for canonical / JSON-LD. Prefer env so prerender (localhost) still points to prod domain.
 * Her zaman www’siz kök domain (CNAME/301 ile www yönlendirmesi sunucu tarafında tamamlanır).
 */
export function getPublicSiteUrl() {
  const fromEnv =
    (typeof process !== 'undefined' &&
      process.env &&
      (process.env.REACT_APP_PUBLIC_SITE_URL || process.env.REACT_APP_BACKEND_URL)) ||
    '';
  if (fromEnv) return stripWwwOrigin(String(fromEnv).replace(/\/$/, ''));
  if (typeof window !== 'undefined' && window.location?.origin) {
    return stripWwwOrigin(window.location.origin);
  }
  return '';
}

export function stripHtmlForMeta(html, maxLen = 160) {
  if (!html) return '';
  const text = String(html)
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (text.length <= maxLen) return text;
  return `${text.slice(0, Math.max(0, maxLen - 1))}…`;
}

/** site + path → tam canonical. path '/' veya boşsa yalnızca origin. */
export function joinSitePath(site, path) {
  if (!site) return '';
  const base = String(site).replace(/\/$/, '');
  if (!path || path === '/') return base;
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}

export function absoluteImageUrl(siteBase, url) {
  if (!url) return '';
  const s = String(url).trim();
  if (/^https?:\/\//i.test(s)) return s;
  if (!siteBase) return s;
  return `${siteBase}${s.startsWith('/') ? '' : '/'}${s}`;
}

const PRIVATE_ROOTS = new Set([
  'cart',
  'login',
  'register',
  'forgot-password',
  'reset-password',
  'verify-email',
  'registration-success',
  'resend-verification',
  'search',
  'ai',
  'track',
  'my-appointments',
  'checkout',
  'dashboard',
  'account',
  'orders',
  'admin',
  'seller',
  'wishlist',
]);

/**
 * Sepet, hesap, arama ve oturumluk rezervasyon sayfaları indekslenmesin.
 * Yol, yerelleştirilmiş slug’lar İngilizce segmente çevrildikten sonra okunur.
 */
export function shouldNoindexPath(pathname) {
  const segs = pathnameToEnglishSegments(pathname || '/');
  const first = segs[0] || '';
  const joined = segs.join('/');
  if (PRIVATE_ROOTS.has(first)) return true;
  if (joined.startsWith('newsletter/unsubscribe')) return true;
  if (joined.startsWith('hotels/booking')) return true;
  if (joined.startsWith('flights/booking')) return true;
  if (joined.startsWith('car-rentals/booking')) return true;
  if (joined.startsWith('taxi-limousine/booking')) return true;
  if (joined.startsWith('supermarkets/order')) return true;
  if (first === 'hotels' && segs[1] && segs[1] !== 'booking') return true;
  if (joined === 'membership/success') return true;
  return false;
}
